module.exports = __webpack_public_path__ + "img/4.582d6de1.png";